import { XCloseGray } from "../../../../core/icons/XClose";
import { ProfilePreviewProps } from "../interfaces/ProfilePreviewInterface";
import { UserView } from "../../../../core/components/UserView";
import { CheckVerify } from "../../../../core/icons/CheckVerify";
import { sortPhotos } from "../../../../core/constants/constants";
import { SkeletonUserInfo } from "../../../../core/components/SkeletonUserInfo";

export const extractCountry = (address: string): string | null => {
    const parts = address.split(",");
    const country = parts[parts.length - 1].trim();
    return country || null;
  };
  
const ProfilePreview: React.FC<ProfilePreviewProps> = ({
    Ref,
    username,
    desires,
    interest,
    birth,
    sexual_orientation,
    marital_status,
    bio,
    gender,
    verify,
    distance,
    pictures,
    children,
    location,
    handleProfilePreview,
    isCurrentUser,
    isBlur = true,
    last_logged_in_time,
    show_last_logged,
    partner,
    loading = false,
    country
}) => {
    const resume = [
        birth,
        gender,
        sexual_orientation,
        marital_status,
        distance,
    ].filter(Boolean).join(", ");
    const resumeMe = [
        birth,
        gender,
        sexual_orientation,
        marital_status,
    ].filter(Boolean).join(", ");


    const countryLocation  = extractCountry(location || "");

    return (
        <article
            ref={Ref}
            className={`fixed z-30 top-0 left-0 max-sm:h-svh h-full max-sm:max-h-svh max-sm:overflow-hidden sm:h-4/5 sm:max-h-[43rem] sm:top-1/2 sm:left-1/2 transform sm:-translate-x-1/2 sm:-translate-y-1/2 transition-transform max-sm:w-full`}
        >
            {loading ? 
                <SkeletonUserInfo />
                : 
                <UserView
                    pictures={pictures && sortPhotos(pictures)}
                    name={username}
                    verify={(verify === true || verify === "verified") ? <CheckVerify /> : <CheckVerify color="#c5c5c5" />}
                    resume={isCurrentUser ? resumeMe : resume}
                    location={`${countryLocation || "-"}`}
                    aboutMe={bio}
                    desires={desires}
                    interest={interest}
                    isBlur={isBlur}
                    last_logged_in_time={last_logged_in_time}
                    show_last_logged={show_last_logged}
                    partner={partner}
                    country={country}
                    >
                    <button
                        onClick={handleProfilePreview}
                        aria-label="Close Preview Profile"
                        className="max-sm:text-black max-sm:order-first max-sm:self-end max-sm:pt-6 max-sm:pr-6 sm:absolute sm:top-0 sm:-right-8 text-white hover:text-grayLight2"
                        >
                        <XCloseGray />
                    </button>
                    {children}
                </UserView>
            }
        </article>
    );
};

export default ProfilePreview;
